
import { Component, Vue, Prop } from 'vue-property-decorator';
import VueI18n from 'vue-i18n';

@Component({
    name: 'FormItem',
})
export default class FormItem extends Vue {
    @Prop({
        required: false,
        default: 'FORM ITEM WITH NO TITLE',
    })
    title: string | VueI18n.TranslateResult;

    @Prop({
        required: false,
        default: 'is-12',
    })
    size: string;
}
